import { FC, JSX, useEffect, useMemo, useState } from "react";
import { GenerateForm } from "./GenerateForm";
import { WidgetStepType } from "shared/types";

const DynamicForm: FC<WidgetStepType> = ({ fields, id }) => {
  const [formComponents, setFormComponents] = useState<JSX.Element[]>([]);

  // Loading dynamic CSS
  useMemo(() => {
    import(`styles/configurations/${id.toString()}.css`).catch((error) =>
      console.error(`Failed to load CSS for ${id}:`, error)
    );
  }, [id]);

  // Generating components based on the JSON
  useEffect(() => {
    const components = GenerateForm(fields);
    setFormComponents(components);
  }, [fields]);

  return <main className={id}>{formComponents}</main>;
};

export default DynamicForm;
